var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.gallery_id}},_vm._l((_vm.get_images),function(image,key){return _c('gallery-item',{key:key,ref:"gallery_item",refInFor:true,attrs:{"image_src":image.image_src,"image_src_lazy":image.image_lazy_src,"gallery_src":image.gallery_image}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }